const api = async (context, service, showMessage = true) => {
  try {
    const response = await service;

    if (showMessage) {
      context.$toastNotifPrime('success', 'Success', response.data.message || "Operation completed successfully")
    }
    return response.data;
  } catch (error) {
    if (showMessage) {
      const errorData = error.response?.data;
      let errorMessage = 'Something went wrong';

      if (errorData) {
        if (typeof errorData.message === 'string') {
          errorMessage = errorData.message;
        } else if (errorData.error && typeof errorData.error === 'string') {
          errorMessage = errorData.error;
        } else if (errorData.data && typeof errorData.data === 'object') {
          // Handle validation errors or nested data objects
          const firstKey = Object.keys(errorData.data)[0];
          const firstVal = errorData.data[firstKey];
          errorMessage = Array.isArray(firstVal) ? firstVal[0] : firstVal;
        }
      } else {
        errorMessage = error.message;
      }

      context.$toastNotifPrime('error', 'Error', errorMessage)
    }
    throw error;
  }
};

export default api;
